import { ReactNode, useState } from "react";
import { Row } from "@narmi/design_system";
import Modal, { type ModalDetailsTypes } from "./Modal";

type DetailsProps = {
  children: ReactNode;
  ariaLabel?: string;
  type?: ModalDetailsTypes;
  label?: string;
};

const Details = ({
  label,
  children,
  type = "details",
  ariaLabel,
}: DetailsProps) => {
  const [open, setOpen] = useState(false);

  const childrenContainerClassName = () => {
    if (type === "wide details") {
      return "narmi-grid-content";
    } else if (type === "wide details responsive") {
      return "narmi-grid-content details-responsive-grid-content";
    } else {
      return "";
    }
  };

  const toggleMenu = () => {
    setOpen((isOpen) => !isOpen);
  };

  return (
    <div className="nds-details navbar-nds-btn">
      <button
        type="button"
        onClick={toggleMenu}
        aria-label={ariaLabel}
        className="button--reset topMenu-button"
      >
        <Row gapSize="xs" alignItems="center">
          <Row.Item>{label}</Row.Item>
          <Row.Item shrink>
            <span className={`narmi-icon-chevron-${open ? "up" : "down"}`} />
          </Row.Item>
        </Row>
      </button>
      <Modal type={type} open={open} setOpen={setOpen} nullIfClosed>
        <div
          className={`nds-details-container ${
            type === "wide details" ? "narmi-grid-container" : ""
          }`}
        >
          <div className={childrenContainerClassName()}>{children}</div>
        </div>
      </Modal>
    </div>
  );
};

export default Details;
